const NAME = "KPI_DEFINITION_PAGE";

export default NAME;
